<h2 mat-dialog-title>{{ 'SelectACompanyLogo' | translate: {Default: "Select A Company Logo"} }}</h2>

<mat-dialog-content>
    <div *ngIf="selectedCompanyLogo" class="selected-company-logo page-description-section">
        <h6>{{ 'SelectedCompanyLogo' | translate: {Default: "Selected company logo"} }}: {{selectedCompanyLogo.name}}</h6>
    </div>

    <app-data-grid-comp
        [columns]="columns"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectableMode: 'single',
            selectRowBy: 'id'
        }"
        clickableRows="false"
        hideActionButtons="true"
        [clearSelectedItems]="clearSelectedItems"
        [selectedRowsButtonSettings]="selectedRowsButtonSettings"
        (emitPageChangeEvent)="pageChange($event)"
        (emitSelectedRows)="selectedRowsChanged($event)"
    ></app-data-grid-comp>

</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!selectedCompanyLogo">{{ 'Save' | translate: {Default: "Save"} }}</button>
</mat-dialog-actions>

